import { GET_AUCTION_FORMS } from "core/apollo/graphql";
import { DOCS_FORM_NAMES, SEARCH_ACTION_DELETE_FORM } from "core/consts";
import { useApolloEncryptionContext } from "core/model/patients/encryption/utils";
import { getErrorMessage } from "core/model/utils/errors";
import { Auction, DocsFormName, RehabFormName } from "core/types";
import { useDeleteUnsharedFileByType } from "dsl/ecosystems/PatientFiles/useDeleteUnsharedFileByType";
import { getRehabFormConfig } from "dsl/ecosystems/PatientForms/RehabForms/configs";
import useSearchAction from "dsl/hooks/useSearchAction";
import { FORM_NAME_TO_FILE_TYPE } from "./utils";

export function useDeleteConfirmation({
  auction,
  formName,
}: {
  auction: Auction;
  formName: DocsFormName;
}) {
  const encryptionContext = useApolloEncryptionContext({ decrypt: true });

  const [deleteForm, deleteFormProgress] = useSearchAction({
    actionType: SEARCH_ACTION_DELETE_FORM,
    refetchQueries: [
      {
        context: { encryptionContext },
        query: GET_AUCTION_FORMS,
        variables: {
          auctionId: auction.id,
        },
      },
    ],
  });

  const { formSubType, formType } =
    formName === DOCS_FORM_NAMES.TRANSITIONAL_CARE
      ? { formSubType: undefined, formType: undefined }
      : getRehabFormConfig(formName as RehabFormName) ?? {};

  const { deleteUnsharedFile } = useDeleteUnsharedFileByType({
    auctionId: auction.id,
    formSubType,
    formType,
  });

  const onDelete = async () => {
    try {
      await deleteForm({
        auction,
        context: {
          form_type: FORM_NAME_TO_FILE_TYPE[formName],
        },
      });

      await deleteUnsharedFile();
    } catch (err) {
      console.error(`error deleting ${formName} form: ${getErrorMessage(err)}`);
    }
  };

  return {
    deleteFormProgress,
    onDelete,
  };
}
